import React, { Component } from 'react';
import { Form, Grid, Button } from 'semantic-ui-react';
import { SikdaeGroup, SikdaePolicy, Division, SearchInputBox } from 'components/Commons';

class RemnantsForm extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      sikdaeGroupVal,
      sikdaeGroup,
      sikdaeGroupSearch,
      sikdaePolicy,
      submitForm,
      division,
      handleEntSubmit
    } = this.props.formFn;

    return(
      <Form  className="top-form">
        <Grid>
          <Grid.Row className="form-row" style={{marginBottom: -10}}>
            <Grid.Column width={14}>
              <Form.Group>
                <SikdaeGroup
                  sikdaeGroup={sikdaeGroup}
                  sikdaeGroupSearch={sikdaeGroupSearch}
                />
                <SikdaePolicy
                  sikdaeGroupVal={sikdaeGroupVal}
                  sikdaePolicy={sikdaePolicy}
                />
                <SearchInputBox
                  handleSubmit={submitForm}
                  handleEntSubmit={handleEntSubmit}
                  placeHolder={"ID, 이름"}
                />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button
                color="black" inverted
                content='조회'
                onClick={submitForm}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Division division={division} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export default RemnantsForm;
